<script>
  import { Headline, Photo, Video, SvgFolderST } from '@st-graphics/graphics-components'
  import { boolean } from '@st-graphics/graphics-kit/utils'

  let {
    navbar,
    covermode = 'image',
    src,
    autoplay = true,
    loop = true,
    poster = undefined,
    headline,
    deck,
    byline,
    datetime,
    modifieddatetime,
    menuitems,
    hasdesktop = 'false',
    mobiledeck = 'true',
    maxheight = '300px',
    minheight = '100vh',
    maxwidth = '100%',
    balancehed = true,
    balancedek = true,
    alt,
  } = $props()
</script>

{@render navbar?.()}

<div class="main-headline-head-wrapper cover-{covermode}">
  {#if covermode !== 'svg'}
    <div
      class="media-wrap"
      style:max-height={maxheight}
      style:height={maxheight}
      style:max-width={maxwidth}
    >
      {#if covermode === 'image'}
        <Photo {src} hasdesktop={boolean(hasdesktop)} {alt} />
      {:else if covermode === 'video'}
        <Video
          {src}
          hasdesktop={boolean(hasdesktop)}
          {autoplay}
          {loop}
          {poster}
          autoplayonscroll={false}
          {alt}
        />
      {/if}
    </div>
  {:else}
    <div class="media-wrap" style:min-height={minheight} style:max-width={maxwidth}>
      <SvgFolderST srcfolder={src} {alt} />
    </div>
  {/if}

  {@render menuitems?.()}

  <div class="article-headline">
    <Headline
      hed={headline}
      dek={deck}
      mobiledeck={boolean(mobiledeck)}
      {byline}
      {datetime}
      {modifieddatetime}
      balancehed={boolean(balancehed)}
      balancedek={boolean(balancedek)}
    />
  </div>
</div>

<style lang="scss">
  .main-headline-head-wrapper {
    .media-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: fit-content;
      position: relative;
      height: 100%;
      width: 100%;
      overflow: hidden;
      margin: 0 auto;

      :global(figure) {
        width: 100%;
        height: 100%;
      }
      :global(div) {
        width: 100%;
        height: 100%;
      }
      :global(img),
      :global(video) {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .article-headline {
      --headline-dek-color: currentcolor;
      --headline-metadata-color: currentcolor;
      --link-color: currentcolor;
      --link-text-decoration-color: currentcolor;
    }
  }

  :global(.cover-image .headline .wrapper:last-of-type) {
    border-bottom: 1px dotted var(--article-head-plain-headline-border-color, var(--st-medium-gray));
  }
</style>
